import { render } from "./SchList.vue?vue&type=template&id=4d5797e7&scoped=true"
import script from "./SchList.vue?vue&type=script&lang=js"
export * from "./SchList.vue?vue&type=script&lang=js"

import "./SchList.vue?vue&type=style&index=0&id=4d5797e7&scoped=true&lang=scss"

import exportComponent from "D:\\work\\粤智康医药网\\guanwang\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d5797e7"]])

export default __exports__